/**
 * DASH-3168: mirrors the BE `HazardCategory` enum
 * (Web.Api.Core/Domain/Enums/HazardCategory.cs). The integer values are a
 * persisted contract and MUST match the BE exactly — never re-number them.
 *
 * A hazard CLASSIFICATION of an agent — an orthogonal dimension to
 * {@link SampleTypeEnum}, which is a SAMPLING METHOD, not a hazard class.
 * Deliberately spelled `Psychosocial` (the hazard class that is assessed, per
 * ISO 45003), NOT `Psychological` (the health OUTCOME it causes, which
 * `SampleTypeEnum.Other` still uses elsewhere). Do not align the two.
 */
export enum HazardCategory {
    Chemical = 0,
    Physical = 1,
    Biological = 2,
    Psychosocial = 3,
}

/**
 * Display labels for each category. Kept in the same file as the enum so a value
 * change breaks this map at compile time. The label IS the i18n key (English
 * source text) — resolve through the translate pipe / `getDynamicTranslation`.
 */
export const HAZARD_CATEGORY_DISPLAY_LABELS: Record<HazardCategory, string> = {
    [HazardCategory.Chemical]: 'Chemical',
    [HazardCategory.Physical]: 'Physical',
    [HazardCategory.Biological]: 'Biological',
    [HazardCategory.Psychosocial]: 'Psychosocial',
};

/**
 * Canonical tab order for the Risk Assessment matrix. The risk-register renders
 * one tab per category PRESENT in the assessment, filtered from this order so the
 * tab sequence is stable regardless of the order the BE returns distinct values.
 */
export const HAZARD_CATEGORY_ORDER: HazardCategory[] = [
    HazardCategory.Chemical,
    HazardCategory.Physical,
    HazardCategory.Biological,
    HazardCategory.Psychosocial,
];
